import blogFetch from "../../axios/config";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { useEffect, useRef, useState } from "react";
import "./ListMontagem.css";
import Loading from "../../components/Loading";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import QRCodeReaderListaMontagem from "./QRCodeReaderListaMontagem";

export default function ListMontagem() {
    const [montagens, setMontagens] = useState([]);
    const [componente, setComponente] = useState([]);
    const [ordem, setOrdem] = useState("");
    const inputRef = useRef(null);
    const imagemurl = "https://ingsglass.file.core.windows.net/ingsglass/BRASIL/";
    const token =
        ".jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwlacupitfx&se=2033-05-04T04:42:27Z&st=2023-05-03T20:42:27Z&spr=https,http&sig=DBpnOqlwSWJgqZgPjRm5uCJ%2BgUIWicQ5cKPNhUQfNWI%3D";
    const [imagemUrl, setImagemUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [zoomAtivo, setZoomAtivo] = useState(false);
    const [codigoLido, setCodigoLido] = useState("");

    const fetchData = async (ordem) => {
        setLoading(true);
        try {
            const { data } = await blogFetch.get(`/MaterialReserve/${ordem}`);
            setMontagens(data);

            const res = await blogFetch.get(`SAGAViewFichaCabecalho/${ordem}`);
            let imagemCodigo = res.data[0]._Plano;
            setImagemUrl(`${imagemurl}${imagemCodigo}${token}`);

            const componets = await blogFetch.get(`SAGAViewFichaComponentes/caracteristica/${ordem}`);
            setComponente(componets.data);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setMontagens([]);
            setImagemUrl(null);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = async (e) => {
        if (e.key === "Enter") {
            const value = e.target.value.trim();
            if (value !== "") {
                await fetchData(value);
                setOrdem("");
            }
        }
    };

    const clearFields = () => {
        setOrdem("");
        inputRef.current?.focus();
    };

    useEffect(() => {
        if (codigoLido) {
            (async () => {
                await fetchData(codigoLido);
                setCodigoLido("");
                setOrdem("");
            })();
        }
    }, [codigoLido]);

    useEffect(() => {
    }, []);

    return (
        <div className="container_listaMontagem">
            <Navbar />
            <Sidebar />

            <div className="app_body appBody_listaMontagem">
                <div className="row_listaMontagem">
                    <h1 className="titulo_listaMontagem">Listagem de Montagem</h1>

                    <div className="inputWrapper_listaMontagem">

                        <QRCodeReaderListaMontagem setCode={(codigo) => setCodigoLido(codigo)} />

                        <input
                            type="text"
                            ref={inputRef}
                            className="inputOrdem_listaMontagem"
                            placeholder="Digite o número da ordem"
                            value={ordem}
                            onChange={(e) => setOrdem(e.target.value)}
                            onKeyDown={handleKeyDown}
                            autoComplete="off"
                            autoFocus
                        />


                    </div>

                    <div className="listaMontagemContainer">
                        {loading ? (
                            <div className="loadingContainer">
                                <Loading />
                            </div>
                        ) : montagens.length > 0 ? (
                            <div className="conteudo_listaMontagem">
                                <div className="tabelaWrapper_listaMontagem">
                                    <table className="tabela_listaMontagem">
                                        <thead>
                                            <tr>
                                                <th>Caract</th>
                                                <th>Código</th>
                                                <th>Posição</th>
                                                <th>Material</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {montagens  
                                                .filter(
                                                    (montagem) =>
                                                        !montagem.COD_MATERIAL.startsWith("303") &&
                                                        !montagem.ORDEM_MATERIAL.endsWith("99") &&
                                                        !montagem.MATERIAL.includes("FLEXILINE")
                                                )
                                                .map((montagem, index) => {
                                                    const compCorrespondente = componente.find(
                                                        (comp) => comp.pos === montagem.ORDEM_MATERIAL
                                                    );

                                                    return (
                                                        <tr key={`montagem-${index}`}>
                                                            <td>{compCorrespondente?.descricao_Eng || "-"}</td>
                                                            <td>{montagem.COD_MATERIAL}</td>
                                                            <th>{montagem.ORDEM_MATERIAL}</th>
                                                            <th>{montagem.MATERIAL}</th>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>

                                {imagemUrl && (
                                    <div className="imagemWrapper_listaMontagem">
                                        <div className="zoomContainer">
                                            <img
                                                src={imagemUrl}
                                                alt="Imagem da Ordem"
                                                className="imagem_listaMontagem"
                                                onDoubleClick={() => setZoomAtivo((prev) => !prev)}
                                            />
                                        </div>
                                    </div>
                                )}

                                {zoomAtivo && (
                                    <div
                                        className="zoomModal_overlay"
                                    >
                                        <TransformWrapper
                                            initialScale={1}
                                            minScale={1}
                                            maxScale={6}
                                            wheel={{ step: 0.2 }}
                                            doubleClick={{ disabled: true }}
                                            panning={{ velocityDisabled: true }}
                                        >
                                            {({ zoomIn, zoomOut, resetTransform, state }) => (
                                                <div className="zoomArea">
                                                    <div className="zoomControls">
                                                        <button onClick={() => zoomIn()}>➕</button>
                                                        <button onClick={() => zoomOut()}>➖ </button>
                                                        <button onClick={() => resetTransform()}>↩</button>
                                                        <button title="Fechar" onClick={() => setZoomAtivo(false)} style={{ background: '#dc2626' }}>✕</button>
                                                    </div>

                                                    <TransformComponent>
                                                        <img
                                                            src={imagemUrl}
                                                            alt="Zoom"
                                                            className="zoomModal_image"
                                                            draggable="false"
                                                        />
                                                    </TransformComponent>
                                                </div>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p></p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
